<div class="p-6">
  <div class="flex flex-col md:flex-row md:items-center gap-4 mb-6">
    <h3 class="font-bold text-xl">{{ '::ColppyHealthCheck' | abpLocalization }}</h3>
    <app-metro-button
      variant="secondary"
      text="{{ '::Refresh' | abpLocalization }}"
      (clicked)="refresh()"
      class="md:ml-auto">
    </app-metro-button>
  </div>

  @if (isLoading) {
    <div class="flex justify-center items-center py-12">
      <div class="text-center">
        <div class="mx-auto mb-4" style="width: 48px; height: 48px; border: 4px solid rgba(0,0,0,0.1); border-left-color: #4A5568; border-radius: 50%; animation: donut-spin 1.2s linear infinite;"></div>
        <p class="text-metro-blue-secondary font-medium">{{ '::Loading' | abpLocalization }}...</p>
      </div>
    </div>
  } @else {
    <!-- Resumen de Logs -->
    <div class="mb-8">
      <h4 class="font-semibold text-lg mb-4">{{ '::LogsSummary' | abpLocalization }}</h4>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div class="bg-white rounded-lg border border-gray-200 p-4">
          <div class="text-sm text-gray-600 mb-1">{{ '::TotalLogs' | abpLocalization }}</div>
          <div class="text-2xl font-bold text-gray-800">{{ healthCheckData?.logsSummary?.totalLogs || 0 }}</div>
        </div>
        <!-- Comentado temporalmente
        <div class="bg-red-50 rounded-lg border border-red-200 p-4">
          <div class="text-sm text-red-600 mb-1">Errores</div>
          <div class="text-2xl font-bold text-red-800">{{ healthCheckData?.logsSummary?.errorLogs || 0 }}</div>
        </div>
        <div class="bg-yellow-50 rounded-lg border border-yellow-200 p-4">
          <div class="text-sm text-yellow-600 mb-1">Advertencias</div>
          <div class="text-2xl font-bold text-yellow-800">{{ healthCheckData?.logsSummary?.warningLogs || 0 }}</div>
        </div>
        -->
        <div class="bg-blue-50 rounded-lg border border-blue-200 p-4">
          <div class="text-sm text-blue-600 mb-1">{{ '::InformationLogs' | abpLocalization }}</div>
          <div class="text-2xl font-bold text-blue-800">{{ healthCheckData?.logsSummary?.informationLogs || 0 }}</div>
        </div>
      </div>

      <!-- Comentado temporalmente
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div class="bg-red-100 rounded-lg border border-red-300 p-4">
          <div class="text-sm text-red-700 mb-1">Errores Sin Resolver</div>
          <div class="text-xl font-bold text-red-900">{{ healthCheckData?.logsSummary?.unresolvedErrors || 0 }}</div>
        </div>
        <div class="bg-orange-100 rounded-lg border border-orange-300 p-4">
          <div class="text-sm text-orange-700 mb-1">Vinos con Errores</div>
          <div class="text-xl font-bold text-orange-900">{{ healthCheckData?.logsSummary?.winesWithErrors || 0 }}</div>
        </div>
        <div class="bg-purple-100 rounded-lg border border-purple-300 p-4">
          <div class="text-sm text-purple-700 mb-1">PickUps con Errores</div>
          <div class="text-xl font-bold text-purple-900">{{ healthCheckData?.logsSummary?.pickUpsWithErrors || 0 }}</div>
        </div>
      </div>
      -->
    </div>

    <!-- Vinos sin idItemColppy -->
    <div class="mb-8">
      <h4 class="font-semibold text-lg mb-4">
        {{ '::WinesWithoutIdItem' | abpLocalization }}
        <span class="text-sm font-normal text-gray-600 ml-2">
          ({{ healthCheckData?.winesWithoutIdItem?.length || 0 }})
        </span>
      </h4>
      @if (healthCheckData?.winesWithoutIdItem && healthCheckData.winesWithoutIdItem.length > 0) {
        <div class="flex flex-col overflow-x-auto rounded-lg border-1 border-gray-700">
          <app-metro-table
            [columns]="wineColumns"
            [data]="healthCheckData.winesWithoutIdItem"
            [pageSize]="10"
            [currentPage]="1"
            [isServerPaginated]="false">
          </app-metro-table>
        </div>
      } @else {
        <div class="bg-green-50 border border-green-200 rounded-lg p-4 text-center">
          <p class="text-green-800">{{ '::AllWinesHaveIdItem' | abpLocalization }}</p>
        </div>
      }
    </div>

    <!-- Vinos con IdItemColppy duplicado -->
    <div class="mb-8">
      <h4 class="font-semibold text-lg mb-4">
        {{ '::WinesWithDuplicateIdItem' | abpLocalization }}
        <span class="text-sm font-normal text-gray-600 ml-2">
          ({{ healthCheckData?.winesWithDuplicateIdItem?.length || 0 }})
        </span>
      </h4>
      @if (healthCheckData?.winesWithDuplicateIdItem && healthCheckData.winesWithDuplicateIdItem.length > 0) {
        <div class="flex flex-col overflow-x-auto rounded-lg border-1 border-gray-700">
          <app-metro-table
            [columns]="duplicateIdItemColumns"
            [data]="healthCheckData.winesWithDuplicateIdItem"
            [pageSize]="10"
            [currentPage]="1"
            [isServerPaginated]="false">
          </app-metro-table>
        </div>
      } @else {
        <div class="bg-green-50 border border-green-200 rounded-lg p-4 text-center">
          <p class="text-green-800">{{ '::NoWinesWithDuplicateIdItem' | abpLocalization }}</p>
        </div>
      }
    </div>

    <!-- PickUps sin ColppyWarehouseName -->
    <div class="mb-8">
      <h4 class="font-semibold text-lg mb-4">
        {{ '::PickUpsWithoutColppyWarehouse' | abpLocalization }}
        <span class="text-sm font-normal text-gray-600 ml-2">
          ({{ healthCheckData?.pickUpsWithoutColppyWarehouse?.length || 0 }})
        </span>
      </h4>
      @if (healthCheckData?.pickUpsWithoutColppyWarehouse && healthCheckData.pickUpsWithoutColppyWarehouse.length > 0) {
        <div class="flex flex-col overflow-x-auto rounded-lg border-1 border-gray-700">
          <app-metro-table
            [columns]="pickUpColumns"
            [data]="healthCheckData.pickUpsWithoutColppyWarehouse"
            [pageSize]="10"
            [currentPage]="1"
            [isServerPaginated]="false">
          </app-metro-table>
        </div>
      } @else {
        <div class="bg-green-50 border border-green-200 rounded-lg p-4 text-center">
          <p class="text-green-800">{{ '::AllPickUpsHaveColppyWarehouse' | abpLocalization }}</p>
        </div>
      }
    </div>

    <!-- Errores Recientes -->
    <div>
      <h4 class="font-semibold text-lg mb-4">
        {{ '::RecentErrors' | abpLocalization }}
        <span class="text-sm font-normal text-gray-600 ml-2">
          ({{ healthCheckData?.logsSummary?.recentErrors?.length || 0 }})
        </span>
      </h4>
      @if (healthCheckData?.logsSummary?.recentErrors && healthCheckData.logsSummary.recentErrors.length > 0) {
        <div class="flex flex-col overflow-x-auto rounded-lg border-1 border-gray-700">
          <app-metro-table
            [columns]="errorColumns"
            [data]="healthCheckData.logsSummary.recentErrors"
            [pageSize]="10"
            [currentPage]="1"
            [isServerPaginated]="false"
            [getRowClass]="getErrorRowClass">
          </app-metro-table>
        </div>
      } @else {
        <div class="bg-green-50 border border-green-200 rounded-lg p-4 text-center">
          <p class="text-green-800">{{ '::NoRecentErrors' | abpLocalization }}</p>
        </div>
      }
    </div>

    <!-- Información del Cache de Disponibilidad de Vinos -->
    <div class="mb-8">
      <h4 class="font-semibold text-lg mb-4">
        {{ '::WineAvailabilityCache' | abpLocalization }}
      </h4>
      @if (healthCheckData?.wineAvailabilityCache?.isEmpty || 
           (!healthCheckData?.wineAvailabilityCache?.warehouses || healthCheckData.wineAvailabilityCache.warehouses.length === 0)) {
        <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-center">
          <p class="text-yellow-800">{{ '::CacheEmpty' | abpLocalization }}</p>
        </div>
      } @else {
        <div class="bg-white rounded-lg border border-gray-200 p-4 mb-4">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div class="bg-blue-50 rounded-lg border border-blue-200 p-4">
              <div class="text-sm text-blue-600 mb-1">{{ '::TotalWarehouses' | abpLocalization }}</div>
              <div class="text-2xl font-bold text-blue-800">{{ healthCheckData?.wineAvailabilityCache?.totalWarehouses || 0 }}</div>
            </div>
            <div class="bg-green-50 rounded-lg border border-green-200 p-4">
              <div class="text-sm text-green-600 mb-1">{{ '::TotalItems' | abpLocalization }}</div>
              <div class="text-2xl font-bold text-green-800">{{ healthCheckData?.wineAvailabilityCache?.totalItems || 0 }}</div>
            </div>
          </div>

          @if (healthCheckData?.wineAvailabilityCache?.warehouses && healthCheckData.wineAvailabilityCache.warehouses.length > 0) {
            <div class="space-y-2">
              @for (warehouse of healthCheckData.wineAvailabilityCache.warehouses; track warehouse.warehouseName) {
                <div class="border border-gray-300 rounded-lg overflow-hidden">
                  <!-- Header del acordeón -->
                  <button
                    type="button"
                    (click)="toggleWarehouse(warehouse.warehouseName)"
                    class="w-full flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 transition-colors text-left"
                    [attr.aria-expanded]="isWarehouseExpanded(warehouse.warehouseName)">
                    <div class="flex items-center gap-3">
                      <svg 
                        class="w-5 h-5 text-gray-600 transition-transform"
                        [class.rotate-90]="isWarehouseExpanded(warehouse.warehouseName)"
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                      </svg>
                      <h5 class="font-semibold text-md">
                        {{ warehouse.warehouseName }}
                        <span class="text-sm font-normal text-gray-600 ml-2">
                          ({{ warehouse.itemCount }} items)
                        </span>
                      </h5>
                    </div>
                  </button>
                  
                  <!-- Contenido colapsable -->
                  @if (isWarehouseExpanded(warehouse.warehouseName)) {
                    <div class="p-4 border-t border-gray-200">
                      @if (warehouse.items && warehouse.items.length > 0) {
                        <div class="mb-2 text-sm text-gray-600">
                          {{ '::ShowingItems' | abpLocalization:warehouse.items.length }}
                        </div>
                        <div class="flex flex-col overflow-x-auto rounded-lg border-1 border-gray-700">
                          <app-metro-table
                            [columns]="cacheItemColumns"
                            [data]="warehouse.items"
                            [pageSize]="10"
                            [currentPage]="1"
                            [isServerPaginated]="false">
                          </app-metro-table>
                        </div>
                      } @else {
                        <p class="text-gray-500 text-sm">{{ '::NoItemsAvailable' | abpLocalization }}</p>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>

    <!-- Sección de Logs Completos -->
    <div class="mt-8">
      <div class="flex items-center justify-between mb-4">
        <h4 class="font-semibold text-lg">{{ '::AllLogs' | abpLocalization }}</h4>
        <app-metro-button
          variant="secondary"
          [text]="showLogsSection ? ('::HideAllLogs' | abpLocalization) : ('::ViewAllLogs' | abpLocalization)"
          (clicked)="toggleLogsSection()">
        </app-metro-button>
      </div>

      @if (showLogsSection) {
        <!-- Filtros -->
        <div class="bg-gray-50 rounded-lg border border-gray-200 p-4 mb-4">
          <h5 class="font-medium text-md mb-3">{{ '::FilterLogs' | abpLocalization }}</h5>
          <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">{{ '::EntityType' | abpLocalization }}</label>
              <select 
                [(ngModel)]="logsFilters.entityType"
                class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm">
                <option value="">{{ '::All' | abpLocalization }}</option>
                <option value="Wine">Wine</option>
                <option value="PickUp">PickUp</option>
              </select>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">{{ '::Operation' | abpLocalization }}</label>
              <input 
                type="text"
                [(ngModel)]="logsFilters.operation"
                [placeholder]="'::Operation' | abpLocalization"
                class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">{{ '::Type' | abpLocalization }}</label>
              <select 
                [(ngModel)]="logsFilters.logType"
                class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm">
                <option [value]="null">{{ '::All' | abpLocalization }}</option>
                <option value="0">{{ '::InformationLogs' | abpLocalization }}</option>
                <option value="1">{{ '::WarningLogs' | abpLocalization }}</option>
                <option value="2">{{ '::ErrorLogs' | abpLocalization }}</option>
              </select>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">{{ '::Severity' | abpLocalization }}</label>
              <select 
                [(ngModel)]="logsFilters.severity"
                class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm">
                <option [value]="null">{{ '::All' | abpLocalization }}</option>
                <option value="0">Baja</option>
                <option value="1">Media</option>
                <option value="2">Alta</option>
                <option value="3">Crítica</option>
              </select>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">{{ '::Status' | abpLocalization }}</label>
              <select 
                [(ngModel)]="logsFilters.isResolved"
                class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm">
                <option [value]="null">{{ '::All' | abpLocalization }}</option>
                <option value="false">Sin Resolver</option>
                <option value="true">{{ '::Resolved' | abpLocalization }}</option>
              </select>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">{{ '::Keyword' | abpLocalization }}</label>
              <input 
                type="text"
                [(ngModel)]="logsFilters.keyword"
                [placeholder]="'::SearchInMessage' | abpLocalization"
                class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm">
            </div>
          </div>
          <div class="flex gap-2 mt-4">
            <app-metro-button
              variant="primary"
              [text]="'::ApplyFilters' | abpLocalization"
              (clicked)="applyLogsFilters()">
            </app-metro-button>
            <app-metro-button
              variant="secondary"
              [text]="'::ClearFilters' | abpLocalization"
              (clicked)="clearLogsFilters()">
            </app-metro-button>
          </div>
        </div>

        <!-- Tabla de Logs -->
        @if (isLoadingLogs) {
          <div class="flex justify-center items-center py-12">
            <div class="text-center">
              <div class="mx-auto mb-4" style="width: 48px; height: 48px; border: 4px solid rgba(0,0,0,0.1); border-left-color: #4A5568; border-radius: 50%; animation: donut-spin 1.2s linear infinite;"></div>
              <p class="text-metro-blue-secondary font-medium">{{ '::Loading' | abpLocalization }} {{ '::Logs' | abpLocalization }}...</p>
            </div>
          </div>
        } @else {
          <div class="flex flex-col overflow-x-auto rounded-lg border-1 border-gray-700">
            <app-metro-table
              [columns]="logsColumns"
              [data]="logsData.items"
              [pageSize]="logsPageSize"
              [currentPage]="currentLogsPage"
              [totalItems]="logsData.totalCount"
              [isServerPaginated]="true"
              [getRowClass]="getLogRowClass"
              (pageChange)="onLogsPageChange($event)">
            </app-metro-table>
          </div>
          <div class="mt-2 text-sm text-gray-600">
            {{ '::Showing' | abpLocalization }} {{ (currentLogsPage - 1) * logsPageSize + 1 }} - {{ Math.min(currentLogsPage * logsPageSize, logsData.totalCount) }} {{ '::Of' | abpLocalization }} {{ logsData.totalCount }} {{ '::Logs' | abpLocalization }}
          </div>
        }
      }
    </div>
  }
</div>

